import { createStyles, makeStyles, Theme } from '@material-ui/core'
import colors from 'shared/style/colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textAlign: 'center'
    },
    styled404: {
      color: `${colors.primary}`,
      fontSize: '22vw',
      margin: '0 auto',
      '& > span': {
        color: `${colors.background}`
      }
    },

    titleWrapper: {
      flexDirection: 'column',
      '& h1 , h2 ': { fontWeight: '2em', display: 'flex', flexDirection: 'column', alignItems: 'center' },
      '& h1 > span, & h2 > span': {
        display: 'flex',
        fontWeight: '200'
      }
    },
    linkWrapper: {
      flexDirection: 'column',
      display: 'block',
      margin: 'auto',
      padding: '0',
      '& > a': {
        margin: 'auto',
        display: 'block',
        width: '2rem',
        height: '2rem',
        padding: '0.5rem',
        borderRadius: '2rem',
        backgroundColor: `${colors.background}`
      },
      '& > a > div': {
        padding: 0,
        height: '100%',
        width: '100%',
        backgroundPosition: 'center',
        backgroundSize: '100%',
        transform: 'rotate(180deg)'
      }
    },
    image: {
      boxShadow: '.25rem .25rem .5rem #c0c0c0'
    }
  })
)
